const columns = [
    {
        field: "id",
        headerName: "Invoice #",
        description: "Serial ID for taxed invoices, DB ID for others",
        maxWidth: 100,
        flex: 1,
        valueGetter: (value, row) => {
            // Show serialId for typeId=1 invoices if available, otherwise show regular id
            if (row.typeId === 1 && row.serialId) {
                return row.serialId;
            }
            return value;
        },
    },
    {
        field: "OtherParty",
        headerName: "Customer",
        minWidth: 250,
        flex: 1,
        valueGetter: (OtherParty) => {
            return `${OtherParty?.name}: ${OtherParty?.phone}`;
        },
    },
    {
        field: "InvoiceItem",
        headerName: "Items Count",
        minWidth: 100,
        flex: 1,
        valueGetter: (InvoiceItem) => {
            // Count unique products (aggregated items)
            if (!InvoiceItem || !Array.isArray(InvoiceItem)) return 0;
            const uniqueItems = new Set();
            InvoiceItem.forEach((item) => {
                const key = item.item?.id ?? item.itemId;
                uniqueItems.add(key);
            });
            return uniqueItems.size;
        },
    },
    {
        field: "priceFinal",
        headerName: "price",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "discountPercentage",
        headerName: "discountPercentage",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "employee",
        headerName: "Employee",
        minWidth: 50,
        flex: 1,
        valueGetter: (employee) => {
            return `${employee?.name}`;
        },
    },
    {
        field: "createdAt",
        headerName: "createdAt",
        minWidth: 50,
        flex: 1,
        valueGetter: (createdAt) => {
            return new Date(createdAt).toLocaleString();
        },
    },
];
const addSaleFormFields = [];

const xx = [
    {
        label: "Name",
        name: "name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        width: "49%",
        validate: (value) => (value.trim() === "" ? "Name is required" : ""),
        /*
        onFieldChange: (allFields, value) => {
            const updatedFields = allFields
            updatedFields["barcode"] = value
            return updatedFields
        }
        */
    },
    {
        label: "Barcode",
        name: "barcode",
        type: "text",
        placeholder: "Enter Barcode",
        required: true,
        width: "49%",
    },
    {
        label: "Price",
        name: "priceNormal",
        type: "number",
        placeholder: "Enter Price",
        required: true,
        width: "49%",
    },
    {
        label: "Wholesale Price",
        name: "priceWholesale",
        type: "number",
        placeholder: "Enter Price",
        required: true,
        width: "49%",
    },
    {
        label: "Description",
        name: "description",
        type: "text",
        placeholder: "Enter Description",
    },
    {
        name: "typeId",
        type: "hidden",
        value: 1,
        required: true,
    },
];
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Get_URI = (method, data = {}) => {
    switch (method) {
        case "GET":
            return `${REACT_APP_BACKEND_URL}/invoices`;
        case "POST":
            return `${REACT_APP_BACKEND_URL}/items/create`;
        case "PATCH":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        case "DELETE":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        default:
            return "";
    }
};

export { columns, addSaleFormFields, Get_URI };
